import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckregular = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 256 256",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 16,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		d: "M53.2,141.6L100.8,186.65L209.6,80.4"
	})
});
export default SvgCheckregular;
